import type { SVGAttributes } from 'react';

const IzimiLogo = (props: SVGAttributes<SVGElement>) => (
  <svg
    width={29}
    height={33}
    fill='none'
    viewBox='0 0 29 33'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g>
      <path
        d='M19.582 5.49a5.493 5.493 0 1 1-10.986.007 5.493 5.493 0 0 1 10.986-.007Z'
        fill='#50B2C2'
      />
      <path
        d='m14.078 20.62 4.159 3.927-3.966 4.07a.215.215 0 0 1-.17.08.221.221 0 0 1-.17-.08l-3.846-4.305 3.993-3.692ZM7.468 21.416l-.03 9.82a.755.755 0 0 1-.233.539.803.803 0 0 1-.557.223h-5.26a.803.803 0 0 1-.557-.223.755.755 0 0 1-.233-.54v-16.76l6.87 6.94ZM27.958 14.474v16.757a.746.746 0 0 1-.233.544.793.793 0 0 1-.561.223h-5.131a.807.807 0 0 1-.558-.226.759.759 0 0 1-.232-.54v-9.784l6.715-6.974Z'
        fill='#006D86'
      />
      <path
        d='M.59 7.342v7.132l6.878 6.942 6.459 7.205-3.842-4.309 4.008-3.692L.927 7.306c-.147-.184-.298-.22-.336.036Z'
        fill='#50B2C2'
      />
      <path
        d='M27.618 7.306 14.078 20.62l4.159 3.927 3.025-3.099 6.704-6.966v-7.14c-.038-.256-.19-.22-.34-.036'
        fill='#50B2C2'
      />
    </g>
  </svg>
);

export default IzimiLogo;
